// src/hooks/useCsrfToken.js

import { useState } from "react";
import axios from "axios";
import { baseAxios } from "../apis";

/**
 * useCsrfToken:
 *   - カスタムフックとして、GET /csrf-cookie/ にアクセスし
 *     Cookie にある csrftoken=XXX を取得する手段を提供。
 *   - ここでは state で保持するかどうかは自由だが、
 *     実際には POST直前に freshToken を呼び出し元で受け取りたいので
 *     fetchCsrfToken() が return する形にしている。
 */
export function useCsrfToken() {
  // オプションで、内部 state を用意しても良い
  const [csrfToken, setCsrfToken] = useState("");

  /**
   * fetchCsrfToken
   *   - /csrf-cookie/ (Djangoにて用意されたエンドポイント) にGETリクエスト
   *   - 成功すると Cookie に csrftoken=xxxx がセットされる
   *   - Cookie or レスポンスヘッダ からトークン文字列を取り出して return
   */
  const fetchCsrfToken = async () => {
    try {
      const resp = await baseAxios.get("/api/csrf-cookie/", {
        withCredentials: true,
        
      });
      // レスポンスヘッダ or document.cookie からトークン取得
      const tokenFromHeader =
        resp.headers["x-csrftoken"] ||
        (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] ||
        "";

      if (tokenFromHeader) {
        console.log("[useCsrfToken] Got new CSRF token:", tokenFromHeader);
        // オプション: state に保存しておきたいなら
        setCsrfToken(tokenFromHeader);
        return tokenFromHeader;
      } else {
        console.warn("[useCsrfToken] No CSRF token found in headers or cookies.");
        return "";
      }
    } catch (err) {
      console.error("Error fetching CSRF token:", err);
      return "";
    }
  };

  // このフックは、tokenを保持する state と fetch関数を返す形。
  return {
    csrfToken,       // もしコンポーネントで参照したいなら使う
    fetchCsrfToken,  // POST直前に呼び出し、return値を使う
  };
}
